import { render } from "./RegistrationStart.vue?vue&type=template&id=39c99a4c&scoped=true"
import script from "./RegistrationStart.vue?vue&type=script&lang=js"
export * from "./RegistrationStart.vue?vue&type=script&lang=js"

import "@/Common/Styles/registrationSteps.scss?vue&type=style&index=0&id=39c99a4c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c99a4c"]])

export default __exports__